<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M9.99989 18.0564C14.4489 18.0564 18.0554 14.4498 18.0554 10.0009C18.0554 5.55191 14.4489 1.94531 9.99989 1.94531C5.55093 1.94531 1.94434 5.55191 1.94434 10.0009C1.94434 14.4498 5.55093 18.0564 9.99989 18.0564Z"
            fill="#E4EBFF"
        />
        <path
            d="M4.30298 15.6133C4.34889 15.6133 4.38679 15.6504 4.38696 15.6963C4.38696 15.7423 4.349 15.7803 4.30298 15.7803C4.2571 15.7801 4.21997 15.7422 4.21997 15.6963C4.22015 15.6505 4.25721 15.6135 4.30298 15.6133Z"
            fill="#007AFF"
            stroke="#007AFF"
            stroke-width="1.5"
        />
        <path
            d="M1.94409 9.91602C1.99001 9.91602 2.0279 9.95315 2.02808 9.99902C2.02808 10.045 1.99012 10.083 1.94409 10.083C1.89822 10.0828 1.86108 10.0449 1.86108 9.99902C1.86126 9.95326 1.89833 9.91619 1.94409 9.91602Z"
            fill="#007AFF"
            stroke="#007AFF"
            stroke-width="1.5"
        />
        <path
            d="M4.30298 4.2207C4.34889 4.2207 4.38679 4.25784 4.38696 4.30371C4.38696 4.34973 4.349 4.3877 4.30298 4.3877C4.2571 4.38752 4.21997 4.34963 4.21997 4.30371C4.22015 4.25795 4.25721 4.22088 4.30298 4.2207Z"
            fill="#007AFF"
            stroke="#007AFF"
            stroke-width="1.5"
        />
        <path
            d="M6.91748 17.3574C6.9634 17.3574 7.00129 17.3946 7.00146 17.4404C7.00146 17.4865 6.9635 17.5244 6.91748 17.5244C6.87161 17.5242 6.83447 17.4863 6.83447 17.4404C6.83465 17.3947 6.87171 17.3576 6.91748 17.3574Z"
            fill="#007AFF"
            stroke="#007AFF"
            stroke-width="1.5"
        />
        <path
            d="M2.55737 12.998C2.60329 12.998 2.64118 13.0352 2.64136 13.0811C2.64136 13.1271 2.6034 13.165 2.55737 13.165C2.5115 13.1649 2.47437 13.127 2.47437 13.0811C2.47454 13.0353 2.51161 12.9982 2.55737 12.998Z"
            fill="#007AFF"
            stroke="#007AFF"
            stroke-width="1.5"
        />
        <path
            d="M2.5577 7.7526C3.01794 7.7526 3.39103 7.37951 3.39103 6.91927C3.39103 6.45903 3.01794 6.08594 2.5577 6.08594C2.09746 6.08594 1.72437 6.45903 1.72437 6.91927C1.72437 7.37951 2.09746 7.7526 2.5577 7.7526Z"
            fill="#007AFF"
        />
        <path
            d="M6.91781 3.39128C7.37804 3.39128 7.75114 3.01818 7.75114 2.55794C7.75114 2.09771 7.37804 1.72461 6.91781 1.72461C6.45757 1.72461 6.08447 2.09771 6.08447 2.55794C6.08447 3.01818 6.45757 3.39128 6.91781 3.39128Z"
            fill="#007AFF"
        />
        <path
            d="M10.0001 2.77799C10.4603 2.77799 10.8334 2.4049 10.8334 1.94466C10.8334 1.48442 10.4603 1.11133 10.0001 1.11133C9.53984 1.11133 9.16675 1.48442 9.16675 1.94466C9.16675 2.4049 9.53984 2.77799 10.0001 2.77799Z"
            fill="#007AFF"
        />
        <path
            d="M10.0001 18.8893C10.4603 18.8893 10.8334 18.5162 10.8334 18.056C10.8334 17.5958 10.4603 17.2227 10.0001 17.2227C9.53984 17.2227 9.16675 17.5958 9.16675 18.056C9.16675 18.5162 9.53984 18.8893 10.0001 18.8893Z"
            fill="#007AFF"
        />
        <path
            d="M15.6966 16.5299C16.1569 16.5299 16.5299 16.1569 16.5299 15.6966C16.5299 15.2364 16.1569 14.8633 15.6966 14.8633C15.2364 14.8633 14.8633 15.2364 14.8633 15.6966C14.8633 16.1569 15.2364 16.5299 15.6966 16.5299Z"
            fill="#007AFF"
        />
        <path
            d="M18.0555 10.8327C18.5157 10.8327 18.8888 10.4596 18.8888 9.99935C18.8888 9.53911 18.5157 9.16602 18.0555 9.16602C17.5953 9.16602 17.2222 9.53911 17.2222 9.99935C17.2222 10.4596 17.5953 10.8327 18.0555 10.8327Z"
            fill="#007AFF"
        />
        <path
            d="M15.6966 5.13737C16.1569 5.13737 16.5299 4.76427 16.5299 4.30404C16.5299 3.8438 16.1569 3.4707 15.6966 3.4707C15.2364 3.4707 14.8633 3.8438 14.8633 4.30404C14.8633 4.76427 15.2364 5.13737 15.6966 5.13737Z"
            fill="#007AFF"
        />
        <path
            d="M13.0821 18.2741C13.5423 18.2741 13.9154 17.901 13.9154 17.4408C13.9154 16.9805 13.5423 16.6074 13.0821 16.6074C12.6219 16.6074 12.2488 16.9805 12.2488 17.4408C12.2488 17.901 12.6219 18.2741 13.0821 18.2741Z"
            fill="#007AFF"
        />
        <path
            d="M17.4422 13.9147C17.9025 13.9147 18.2756 13.5416 18.2756 13.0814C18.2756 12.6211 17.9025 12.248 17.4422 12.248C16.982 12.248 16.6089 12.6211 16.6089 13.0814C16.6089 13.5416 16.982 13.9147 17.4422 13.9147Z"
            fill="#007AFF"
        />
        <path
            d="M17.4422 7.7526C17.9025 7.7526 18.2756 7.37951 18.2756 6.91927C18.2756 6.45903 17.9025 6.08594 17.4422 6.08594C16.982 6.08594 16.6089 6.45903 16.6089 6.91927C16.6089 7.37951 16.982 7.7526 17.4422 7.7526Z"
            fill="#007AFF"
        />
        <path
            d="M13.0821 3.39128C13.5423 3.39128 13.9154 3.01818 13.9154 2.55794C13.9154 2.09771 13.5423 1.72461 13.0821 1.72461C12.6219 1.72461 12.2488 2.09771 12.2488 2.55794C12.2488 3.01818 12.6219 3.39128 13.0821 3.39128Z"
            fill="#007AFF"
        />
        <path
            d="M10 5.27734V9.99957L13.6111 12.4996"
            stroke="#007AFF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
